export interface UmpireCurrentTableGroupStats {
  draw: string;

  draw_away: string;

  draw_home: string;

  external_provider_name: string;

  external_team_id: string;

  goals_against: string;

  goals_against_away: string;

  goals_against_home: string;

  goals_diff: string;

  goals_diff_away: string;

  goals_diff_home: string;

  goals_for: string;

  goals_for_away: string;

  goals_for_home: string;

  last_five_matches: string[];

  last_five_matches_away: string[];

  last_five_matches_home: string[];

  lost: string;

  lost_away: string;

  lost_home: string;

  matches_played: string;

  matches_played_away: string;

  matches_played_home: string;

  points: string;

  points_away: string;

  points_home: string;

  position: string;

  position_away: string;

  position_home: string;

  squad_id: string;

  won: string;

  won_away: string;

  won_home: string;
}
